import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyCfPqHbUKL07aPGgjug3bTo_hMOLLF3J1U',
  authDomain: 'app.hirehire.ai',
  projectId: 'something-new-374116',
  appId: '1:622008333070:web:e2bd45a4274b6dcd8a1d5f',
}

export const firebaseApp = initializeApp(firebaseConfig)
export const auth = getAuth(firebaseApp)
export const googleProvider = new GoogleAuthProvider()
